import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { GridComponent, TableMode } from 'src/app/components/grid/grid.component';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { IColumn } from 'src/app/components/grid/IColumn';
import { ITableData } from 'src/app/components/grid/ITableData';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { IExam, IQuestionGroup } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-question-group',
  templateUrl: './question-group.component.html',
  styleUrls: ['./question-group.component.scss']
})
export class QuestionGroupComponent implements OnInit {

  exam: IExam = examDefault;
  
  selectedQuestionGroups: IQuestionGroup[] = [];
  gridName = "questiongroupsGrid";
  selectedQuestionGroup: IQuestionGroup = {
    questionGroupID: "",
    name: "",
    id: 0,
    noOfQuestions: 0,
    examinationID: 0
  };

  mode = "Add";
  @ViewChild("gridComponent") gridComponent!: GridComponent;

  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [
        {
          fieldName: 'examinationID',
          fieldValue: `${this.examService.selectedExamIds?.[0] ?? 0}`,
          queryOperand: QueryOperand['=='],
          static: true
        }
      ],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0,
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    },
  };

  columns: IColumn[] = [
    {
      displayName: "Question Group",
      fieldName: "questionGroupID",
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: "Name",
      fieldName: "name",
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: "No Of Questions",
      fieldName: "noOfQuestions",
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: "Examination ID",
      fieldName: "examinationID",
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,
    }
  ];

  constructor(
    private snackBar: SnackbarService,
    private examService: ExamService,
    private cdRef: ChangeDetectorRef,
    private eventService: EventService,
    private actRoute: ActivatedRoute,
  ) { }

  async ngOnInit() {
    const routeParams = await firstValueFrom(this.actRoute.params);    
    const examID = routeParams['examid'];
    
    if (this.examService.selectedExams?.length === 0) {
      let selectedExam = await this.examService.getExamById(examID) as IExam;
      this.examService.setSelectedExam([selectedExam]);
    } else {
      this.exam = this.examService.selectedExams[0];
    }

    this.setQuestionGroup([]);
    if (this.selectedQuestionGroup?.id) {
      this.mode = "Update";
    } else {
      this.mode = "Add";
    }
    this.setQuestionGroup([]);
    GridUtil.setClearGridSelection();
    await this.refreshData(this.data.tableParams);
  }

  setQuestionGroup(questionGroups: any[]) {
    this.selectedQuestionGroups = questionGroups;
    this.examService.setSelectedQuestionGroup([...this.selectedQuestionGroups]);
  }

  async refreshData(tableParams) {
    const res = (await this.examService.getQuestionGroups(tableParams)) as any[];
    this.updateGridParams(res);
  }

  updateGridParams(res: any) {
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo };
    this.data.tableParams = tableParams;
    this.data.tableRows.push(...res.slice(1, res.length));
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }

  addQuestionGroup() {
    this.mode = "Add";
    this.selectedQuestionGroup = {
      questionGroupID: "",
      name: "",
      id: 0,
      examinationID: 0,
      noOfQuestions: 0
    };
    this.cdRef.detectChanges();
  }

  rowSelectedEvent(questionGroupRowId: any) {
    this.selectedQuestionGroup = (this.data.tableRows[questionGroupRowId[0]] as IQuestionGroup);
    if (this.selectedQuestionGroup?.id) {
      this.mode = "Update";
    } else {
      this.mode = "Add";
    }

    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedQuestionGroup: any[] = [];
    questionGroupRowId.forEach(x => selectedQuestionGroup.push(this.data.tableRows[x]));

    let selectedDataRowsId = storedIds.length > 0 ? storedIds : selectedQuestionGroup.map(x => x.id);
    GridUtil.setRowCliclk(this.gridName, questionGroupRowId, selectedDataRowsId);
    this.setQuestionGroup(selectedQuestionGroup);
  }

  async deleteQuestionGroup() {
    await this.examService
      .deleteQuestionGroup(this.selectedQuestionGroup)
      .then(async (response: any) => {
        this.snackBar.success("Question Group deleted");
        await this.refreshData(this.data.tableParams);
        this.addQuestionGroup();
      });
  }

  async submitQuestionGroup() {
    if (this.selectedQuestionGroup.questionGroupID === "") {
      return this.snackBar.warning("Question Group Id field is required");
    }
    if (this.selectedQuestionGroup.name === "") {
      return this.snackBar.warning("Name field is required");
    }

    this.selectedQuestionGroup.examinationID = this.exam.id;

    console.log(this.selectedQuestionGroup);

    await this.examService
      .saveQuestionGroup(this.selectedQuestionGroup)
      .then((s: any) => {
        this.snackBar.success("Question Group saved");
        this.refreshData(this.data.tableParams);
        if (this.mode === "Add") {
          this.selectedQuestionGroup = {
            questionGroupID: "",
            name: "",
            id: 0, examinationID: 0,
            noOfQuestions: 0
          };
        }
      });
  }
}
